/* tslint:disable */

declare var Object: any;
export interface TtamleavetypeInterface {
  "leaveCode": string;
  "companyId": number;
  "leavenameEn"?: string;
  "leavenameId"?: string;
  "leavenameMy"?: string;
  "leavenameTh"?: string;
  "eligibilityFormula"?: string;
  "daytype": string;
  "deductedleave": string;
  "daycount": string;
  "availableAfter": number;
  "validperiod": number;
  "repeatflag": string;
  "repeatperiod"?: number;
  "entitlementcriteria": number;
  "leaveavailability": string;
  "incrementalDate"?: number;
  "carryover": string;
  "forfeitedperiod"?: number;
  "enableminus": string;
  "maxminus"?: number;
  "rounding"?: string;
  "roundingtype": string;
  "requestDaylimit"?: number;
  "attendCode": string;
  "requestedOnce": string;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "validcriteria": string;
  "proportionalafter": string;
  "extraleave": string;
  "extraleaveFormula"?: string;
  "maxCarryover"?: number;
  "parentFlag"?: string;
  "parentCode"?: string;
  "prolongfor"?: string;
  "unionLeave"?: string;
  "specificEnddate"?: number;
  "specificEndmonth"?: number;
  "specificEndyear"?: number;
  "firstproportionalat"?: string;
  "validateotherstatusfd"?: string;
  "extraleavePeriod"?: number;
  "extraleaveValidperiod"?: number;
  "entitlementSpecificdate"?: number;
  "entitlementSpecificmonth"?: number;
  "firstmonthProrate"?: number;
  "prorateday"?: number;
  "deductionRounding"?: string;
  "deductionRoundingtype"?: string;
  "applytoall"?: boolean;
  ttadempgetleave?: any;
}

export class Ttamleavetype implements TtamleavetypeInterface {
  "leaveCode": string;
  "companyId": number;
  "leavenameEn": string;
  "leavenameId": string;
  "leavenameMy": string;
  "leavenameTh": string;
  "eligibilityFormula": string;
  "daytype": string;
  "deductedleave": string;
  "daycount": string;
  "availableAfter": number;
  "validperiod": number;
  "repeatflag": string;
  "repeatperiod": number;
  "entitlementcriteria": number;
  "leaveavailability": string;
  "incrementalDate": number;
  "carryover": string;
  "forfeitedperiod": number;
  "enableminus": string;
  "maxminus": number;
  "rounding": string;
  "roundingtype": string;
  "requestDaylimit": number;
  "attendCode": string;
  "requestedOnce": string;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "validcriteria": string;
  "proportionalafter": string;
  "extraleave": string;
  "extraleaveFormula": string;
  "maxCarryover": number;
  "parentFlag": string;
  "parentCode": string;
  "prolongfor": string;
  "unionLeave": string;
  "specificEnddate": number;
  "specificEndmonth": number;
  "specificEndyear": number;
  "firstproportionalat": string;
  "validateotherstatusfd": string;
  "extraleavePeriod": number;
  "extraleaveValidperiod": number;
  "entitlementSpecificdate": number;
  "entitlementSpecificmonth": number;
  "firstmonthProrate": number;
  "prorateday": number;
  "deductionRounding": string;
  "deductionRoundingtype": string;
  "applytoall": boolean;
  ttadempgetleave: any;
  constructor(data?: TtamleavetypeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ttamleavetype`.
   */
  public static getModelName() {
    return "Ttamleavetype";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ttamleavetype for dynamic purposes.
  **/
  public static factory(data: TtamleavetypeInterface): Ttamleavetype{
    return new Ttamleavetype(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ttamleavetype',
      plural: 'Ttamleavetypes',
      path: 'Ttamleavetypes',
      properties: {
        "leaveCode": {
          name: 'leaveCode',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "leavenameEn": {
          name: 'leavenameEn',
          type: 'string'
        },
        "leavenameId": {
          name: 'leavenameId',
          type: 'string'
        },
        "leavenameMy": {
          name: 'leavenameMy',
          type: 'string'
        },
        "leavenameTh": {
          name: 'leavenameTh',
          type: 'string'
        },
        "eligibilityFormula": {
          name: 'eligibilityFormula',
          type: 'string'
        },
        "daytype": {
          name: 'daytype',
          type: 'string'
        },
        "deductedleave": {
          name: 'deductedleave',
          type: 'string'
        },
        "daycount": {
          name: 'daycount',
          type: 'string'
        },
        "availableAfter": {
          name: 'availableAfter',
          type: 'number'
        },
        "validperiod": {
          name: 'validperiod',
          type: 'number'
        },
        "repeatflag": {
          name: 'repeatflag',
          type: 'string'
        },
        "repeatperiod": {
          name: 'repeatperiod',
          type: 'number'
        },
        "entitlementcriteria": {
          name: 'entitlementcriteria',
          type: 'number'
        },
        "leaveavailability": {
          name: 'leaveavailability',
          type: 'string'
        },
        "incrementalDate": {
          name: 'incrementalDate',
          type: 'number'
        },
        "carryover": {
          name: 'carryover',
          type: 'string'
        },
        "forfeitedperiod": {
          name: 'forfeitedperiod',
          type: 'number'
        },
        "enableminus": {
          name: 'enableminus',
          type: 'string'
        },
        "maxminus": {
          name: 'maxminus',
          type: 'number'
        },
        "rounding": {
          name: 'rounding',
          type: 'string'
        },
        "roundingtype": {
          name: 'roundingtype',
          type: 'string'
        },
        "requestDaylimit": {
          name: 'requestDaylimit',
          type: 'number'
        },
        "attendCode": {
          name: 'attendCode',
          type: 'string'
        },
        "requestedOnce": {
          name: 'requestedOnce',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "validcriteria": {
          name: 'validcriteria',
          type: 'string'
        },
        "proportionalafter": {
          name: 'proportionalafter',
          type: 'string'
        },
        "extraleave": {
          name: 'extraleave',
          type: 'string'
        },
        "extraleaveFormula": {
          name: 'extraleaveFormula',
          type: 'string'
        },
        "maxCarryover": {
          name: 'maxCarryover',
          type: 'number'
        },
        "parentFlag": {
          name: 'parentFlag',
          type: 'string'
        },
        "parentCode": {
          name: 'parentCode',
          type: 'string'
        },
        "prolongfor": {
          name: 'prolongfor',
          type: 'string'
        },
        "unionLeave": {
          name: 'unionLeave',
          type: 'string'
        },
        "specificEnddate": {
          name: 'specificEnddate',
          type: 'number'
        },
        "specificEndmonth": {
          name: 'specificEndmonth',
          type: 'number'
        },
        "specificEndyear": {
          name: 'specificEndyear',
          type: 'number'
        },
        "firstproportionalat": {
          name: 'firstproportionalat',
          type: 'string'
        },
        "validateotherstatusfd": {
          name: 'validateotherstatusfd',
          type: 'string'
        },
        "extraleavePeriod": {
          name: 'extraleavePeriod',
          type: 'number'
        },
        "extraleaveValidperiod": {
          name: 'extraleaveValidperiod',
          type: 'number'
        },
        "entitlementSpecificdate": {
          name: 'entitlementSpecificdate',
          type: 'number'
        },
        "entitlementSpecificmonth": {
          name: 'entitlementSpecificmonth',
          type: 'number'
        },
        "firstmonthProrate": {
          name: 'firstmonthProrate',
          type: 'number'
        },
        "prorateday": {
          name: 'prorateday',
          type: 'number'
        },
        "deductionRounding": {
          name: 'deductionRounding',
          type: 'string'
        },
        "deductionRoundingtype": {
          name: 'deductionRoundingtype',
          type: 'string'
        },
        "applytoall": {
          name: 'applytoall',
          type: 'boolean'
        },
      },
      relations: {
        ttadempgetleave: {
          name: 'ttadempgetleave',
          type: 'any',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ttamleavetype.ts